export const environment = {
  apiServer: process.env.REACT_APP_SERVER_BASE_URL
};
